import { render, staticRenderFns } from "./CasesDataView.vue?vue&type=template&id=e3f4227e&scoped=true&"
import script from "./CasesDataView.vue?vue&type=script&lang=js&"
export * from "./CasesDataView.vue?vue&type=script&lang=js&"
import style0 from "./CasesDataView.vue?vue&type=style&index=0&id=e3f4227e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f4227e",
  null
  
)

export default component.exports